import { render, staticRenderFns } from "./MeldformulierGemeenten.vue?vue&type=template&id=45e7d9d0&scoped=true&"
import script from "./MeldformulierGemeenten.vue?vue&type=script&lang=js&"
export * from "./MeldformulierGemeenten.vue?vue&type=script&lang=js&"
import style0 from "./MeldformulierGemeenten.vue?vue&type=style&index=0&id=45e7d9d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e7d9d0",
  null
  
)

export default component.exports